import { render } from "./ReservedItems.vue?vue&type=template&id=2f58c3fa&ts=true"
import script from "./ReservedItems.vue?vue&type=script&lang=ts"
export * from "./ReservedItems.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__